import { BaseButton } from 'components/elements';
import { IconDownloadExcel } from 'components/assets/icons';
import { message } from 'antd';
import { excelDownloadAPI } from 'api/common';

export function DownloadExcel({ label = '엑셀 다운로드', params }) {
  const onClickDownload = () => {
    message.info('엑셀 다운로드 중입니다.');
  };

  const fnExcelDownload = async () => {
    try {
      const { data } = await excelDownloadAPI(params);
      if (data) {
        message.info('엑셀 다운로드 중입니다.');
        const link = document.createElement('a');
        link.href = data?.url_path;
        link.setAttribute('download', data?.original_file_name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (err) {
      alert('서버 통신오류입니다.');
      console.error(err);
    }
  };

  return (
    <>
      <BaseButton
        padding={'4px 0px'}
        label={label}
        text
        icon={<IconDownloadExcel />}
        onClick={onClickDownload}
      />
    </>
  );
}
